import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20product%20showcase%20background%20with%20gentle%20organic%20curves%20and%20diffused%20warm%20lighting%2C%20editorial%20ecommerce%20aesthetic%20with%20soft%20terracotta%20and%20cream%20tones%2C%20clean%20elegant%20minimal%20design%20with%20subtle%20texture%2C%20no%20text%20no%20logos%20no%20people&width=1600&height=900&seq=hero-v2-main-2026&orientation=landscape"
          alt="VigorBuy Spreadsheet product showcase background with editorial aesthetic"
          title="VigorBuy Spreadsheet – Complete Buying Guide Background"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-20 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border-2 border-white/30 bg-white/10 backdrop-blur-sm mb-6">
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
          <span className="text-sm text-white/90 font-semibold">Updated Daily</span>
        </div>

        {/* H1 */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-tight mb-6">
          VigorBuy Spreadsheet
          <br />
          <span className="text-white/80 font-medium text-2xl md:text-4xl lg:text-5xl">
            Complete Buying Guide
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover the latest VigorBuy Spreadsheet guides, product resources, safety tips, and buying tutorials. 
          Your trusted resource for informed purchasing decisions.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-bold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer"
          >
            VigorBuy Sheet
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-bold text-foreground-950 bg-white rounded-full hover:bg-white/90 transition-all whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <p className="font-heading text-3xl md:text-4xl font-bold text-white">50+</p>
            <p className="text-sm text-white/60 mt-1">Buying Guides</p>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <p className="font-heading text-3xl md:text-4xl font-bold text-white">100+</p>
            <p className="text-sm text-white/60 mt-1">Resources</p>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <p className="font-heading text-3xl md:text-4xl font-bold text-white">Daily</p>
            <p className="text-sm text-white/60 mt-1">Updates</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}